import { DisplayMode } from '../enums';
import { NavigationData } from '@r-core/controller';

export const navigationDefaults: NavigationData = {
	displayMode: DisplayMode.Overhead,
	activeRef: null,
	islandId: null,
	panelId: null,
	panelPrevId: null
};
